// Update the carousel as and when required.
// Make sure to keep the props contract same as nuka carousel

import React, { Component } from "react";
import { number, object, string } from "prop-types";
import Glide from "@glidejs/glide";
import "./glide-carousel.m.css";
import { StoryElement } from "@quintype/components";
import LightBoxGallery from "../lightBox-gallery";
import LazyEagerImage from "../../atoms/lazy-eager";
export default class GlideCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      carouselName: this.props.storyelements.id,
      showPopup: false,
      elements: this.props.storyelements["story-elements"],
      cdnImage: this.props.cdnImage,
      lightBoxIndex: 0,
      cardWidth: this.props.cardWidth,
      options: {
        startAt: 0,
        peek: 0,
        perView: 1,
        type: "carousel",
        focusAt: "center"
      },
      loader: true
    };
  }

  togglePopup = () => {
    this.setState({ showPopup: !this.state.showPopup });
    this.setState({ lightBoxIndex: this.glide.index });
  };

  normaliseSlideHeight(selector) {
    const slides = document.querySelectorAll(selector);
    const slideHeights = [];

    slides.forEach(slide => slideHeights.push(slide.scrollHeight));

    const tallestSlideHeight = Math.max(...slideHeights);

    slides.forEach(slide => (slide.style.minHeight = tallestSlideHeight + "px"));
  }

  lightBoxNext = () => {
    this.state.lightBoxIndex !== this.state.elements.length - 1
      ? this.setState({ lightBoxIndex: this.state.lightBoxIndex + 1 })
      : this.setState({ lightBoxIndex: 0 });
  };

  lightBoxPrev = () => {
    this.state.lightBoxIndex === 0
      ? this.setState({ lightBoxIndex: this.state.elements.length - 1 })
      : this.setState({ lightBoxIndex: this.state.lightBoxIndex - 1 });
  };

  renderGlideSlider = () => {
    this.glide = new Glide(".glide-" + this.state.carouselName, this.state.options).mount();
  };

  renderSlides = () => {
    return this.state.elements.map((slideritem, index) => {
      const imgS3keys = slideritem["image-s3-key"];
      const elementObj = slideritem;
      const width = (this.state.cardWidth === "tayslevea-wow") ?  "2080" : "980";
      return (
        <div
          className="glide__slide tierBox"
          key={slideritem.id}
          styleName="glide-slide"
          onClick={() => this.togglePopup(index)}
        >
          <figure>
            <LazyEagerImage
              className="image"
              src={`https://${this.state.cdnImage}/${imgS3keys}?w=${width}`}
            />
          </figure>
          {
            (elementObj.title || elementObj["image-attribution"]) && (
              <div styleName="image-title-wrapper" className="voice-no-read">
                {elementObj.title && (
                  <figcaption styleName="img-figcap" className="story-element-image-title">
                    {elementObj.title}
                  </figcaption>
                )}
                {elementObj["image-attribution"] && (
                  <figcaption styleName="img-figcap" className="story-element-image-title">
                    Kuva: {elementObj["image-attribution"]}
                  </figcaption>
                )}
              </div>)
          }
        </div>
      );
    });
  };

  componentDidMount() {
    setTimeout(() => {
      this.renderGlideSlider();
    }, 500);
  }

  render() {
    const leftArrow = (this.state.cardWidth === "tayslevea-wow") ?  "glide-arrow-left-tayslevea" : "glide-arrow-left";
    const rightArrow = (this.state.cardWidth === "tayslevea-wow") ?  "glide-arrow-right-tayslevea" : "glide-arrow-right";
    return (
      <div className="container" styleName="container">
        <div className="tiers" id="tiers">
          <div className={`glide glide-${this.state.carouselName} glide glide-${this.state.carouselName}`}>
            <div className="glide__track" data-glide-el="track">
              <div className="glide__slides" styleName="glide-slides">
                {this.renderSlides()}
              </div>
            </div>
            <div className="glide__arrows" data-glide-el="controls">
              <button
                type="button"
                styleName={`glide-arrow ${leftArrow}`}
                className="glide__arrow glide__arrow--left"
                data-glide-dir="<"
              >
                <i className="ri-arrow-left-s-line"></i>
              </button>
              <button
                type="button"
                styleName={`glide-arrow ${rightArrow}`}
                className="glide__arrow glide__arrow--right"
                data-glide-dir=">"
              >
                <i className="ri-arrow-right-s-line"></i>
              </button>
            </div>
          </div>
        </div>
        {this.state.showPopup && (
          <LightBoxGallery
            element={this.state.elements[this.state.lightBoxIndex]}
            goNext={() => this.lightBoxNext()}
            goPrev={() => this.lightBoxPrev()}
            index={this.state.lightBoxIndex}
            hideNext={this.state.elements.length - 1 === this.state.lightBoxIndex}
            closePopup={() => this.togglePopup()}
          />
        )}
      </div>
    );
  }
}

GlideCarousel.displayName = "GlideCarousel";

GlideCarousel.propTypes = {
  story: object,
  storyelements: object,
  index: number,
  cdnImage:string
};
